import { createExperimentHook } from '@prisjakt/ui-experiment';

export const useProductCollectionSuggestionsExperiment = createExperimentHook(
  'suggest-product-collections',
  { showProductCollectionSuggestions: false },
  {
    'suggest-product-collections': {
      showProductCollectionSuggestions: true,
    },
  }
);

export const useLiftSimilarProductsExperiment = createExperimentHook(
  'lift-similar-products-uk-fr',
  false,
  { lift: true }
);
